module.exports = __webpack_public_path__ + "img/Wanganga-Tob.66043a8d.jpg";